import { useAtom } from 'jotai';
import { useEffect, useRef } from 'react';
import { headerStickyAtom, headerVisibleAtom } from '../../../../atoms/headerAtom';

export const useStickyHeader = (headerRef: any, atSmall: boolean) => {
  const [visible, setVisible] = useAtom(headerVisibleAtom);
  const [sticky, setSticky] = useAtom(headerStickyAtom);
  const prevScrollYRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      setSticky((prevSticky) => {
        if (prevSticky && visible && window.scrollY > 0) {
          return true;
        }

        return window.scrollY > 120;
      });

      if (window.scrollY <= 120) {
        setVisible(true);
        prevScrollYRef.current = 0;
      } else if (window.scrollY > prevScrollYRef.current + 80) {
        prevScrollYRef.current = window.scrollY;
      } else if (window.scrollY < prevScrollYRef.current - 80) {
        setVisible(true);
        prevScrollYRef.current = window.scrollY;
      }

      const currentHeaderRef = headerRef.current;
      if (currentHeaderRef) {
        const headerHeight = 138;
        const newHeight = headerHeight - window.scrollY <= 60 ? 60 : headerHeight - window.scrollY;
        currentHeaderRef.style.height = `${newHeight}px`;
      }
    };

    document.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [atSmall, setSticky, setVisible, visible, headerRef]);

  return { sticky, visible };
};
